import React, {useEffect, useState} from 'react';

import {PopoverBody} from 'reactstrap';

import {StyledPopoverBottomDIV} from 'app/general/bootstrap/utils';
import {type OverlayProps, PopoverForm} from 'app/general/overlays';
import StateButton from 'app/general/widgets/StateButton';
import {gt} from 'app/utils/i18n';

import {GuestAccessUntilField} from './GuestAccessUntilField';

import {useUpdateUser} from '../api';

import type {UserSerializedType} from 'sweet-types';

interface Props {
  overlayProps: OverlayProps;
  user: UserSerializedType;
}

export const EditExpiryTokenTimePopover = ({
  overlayProps,
  user,
}: Props): JSX.Element | null => {
  const [is_guest_until, set_guest_until] = useState<string | null>(
    user.is_guest_until
  );

  const [updateUser] = useUpdateUser();

  useEffect(() => {
    set_guest_until(user.is_guest_until);
  }, [user.is_guest_until]);

  if (user.is_guest_until == null) {
    return null;
  }

  return (
    <PopoverForm overlayProps={overlayProps}>
      {({close, closeOnSuccess}) => {
        return (
          <>
            <PopoverBody className="mb-0 pb-0">
              <GuestAccessUntilField
                inline={false}
                is_guest_until={is_guest_until!}
                onChange={set_guest_until}
              />
            </PopoverBody>
            <StyledPopoverBottomDIV className="d-flex justify-content-between">
              <button onClick={close} className="btn btn-link btn-sm">
                <i className="fa fa-times" /> {gt('Close')}
              </button>
              <StateButton
                onClick={() =>
                  closeOnSuccess(updateUser({id: user.id, is_guest_until}))
                }
                className="btn-primary btn-sm"
                busyText={gt('Save')}
              >
                {gt('Save')}
              </StateButton>
            </StyledPopoverBottomDIV>
          </>
        );
      }}
    </PopoverForm>
  );
};
